const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 结算汇总
const settleSummaryList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/productionCenter/settleSummary/list.vue')),
    'settleSummaryList'
  );
const productionRouter = {
  path: '/production',
  component: index,
  children: [
    {
      path: 'settleSummaryList',
      name: 'settleSummaryList',
      component: settleSummaryList,
      meta: {
        keepAlive: true,
        title: '结算汇总',
      },
    },
  ],
};
export default productionRouter;
